import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import { NAV_LINKS, MBE_LOGO_URL } from '../mock';
import { useCountry, useCtaHandler } from '../context/CountryContext';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { telegramUrl } = useCountry();
  const track = useCtaHandler();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: -12, filter: 'blur(8px)' }}
      animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
      transition={{ duration: 0.7, ease: 'easeOut', delay: 0.2 }}
      className="fixed top-4 left-0 right-0 z-50 px-4"
    >
      <div className={`mx-auto max-w-6xl flex items-center justify-between ${scrolled ? '' : ''}`}>
        {/* Logo */}
        <a href="#top" className="liquid-glass rounded-full flex items-center gap-2 pl-2 pr-3 md:pr-4 py-1.5">
          <img src={MBE_LOGO_URL} alt="MBE International" className="h-7 md:h-9 w-auto object-contain relative z-[1]" />
        </a>

        {/* Center Links */}
        <div className="hidden md:flex liquid-glass rounded-full items-center gap-1 px-1.5 py-1.5">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="px-3 py-2 text-[13px] font-medium text-white/90 hover:text-white uppercase tracking-wide rounded-full relative z-[1]"
            >
              {l.label}
            </a>
          ))}
          <a
            href={telegramUrl}
            target="_blank"
            rel="noreferrer"
            onClick={() => track('nav-join')}
            className="ml-1 bg-white text-black hover:bg-white/95 whitespace-nowrap rounded-full inline-flex items-center gap-1 px-4 py-2 text-[13px] font-semibold uppercase tracking-wide relative z-[1]"
          >
            Join Challenge <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        {/* Right spacer / mobile toggle */}
        <div className="hidden md:block w-11" />
        <button
          className="md:hidden liquid-glass rounded-full p-2.5 text-[#f2f2f2]"
          onClick={() => setOpen(!open)}
          aria-label="menu"
        >
          {open ? <X className="w-4 h-4 relative z-[1]" /> : <Menu className="w-4 h-4 relative z-[1]" />}}
        </button>
      </div>

      {open && (
        <div className="md:hidden mx-auto max-w-6xl mt-2 liquid-glass rounded-3xl p-4 flex flex-col gap-3">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-[#f2f2f2] py-1.5 uppercase tracking-wide text-sm relative z-[1]"
            >
              {l.label}
            </a>
          ))}
          <a
            href={telegramUrl}
            target="_blank"
            rel="noreferrer"
            onClick={() => track('nav-join-mobile')}
            className="bg-white text-black rounded-full inline-flex items-center justify-center gap-1.5 px-4 py-2.5 text-sm font-semibold uppercase relative z-[1]"
          >
            Join Challenge <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      )}
    </motion.div>
  );
}
